import css from './PaymentAmounts.module.css';
import PaymentAmount from '../../Components/PaymentAmount/PaymentAmount';
import {useState} from 'react';


const PaymentAmounts = ({paymentAmounts, handle, setDonationAmount}) => {
	const paymentAmountDefColor = 'rgb(255 125 0)';
	const paymentAmountHoverColor = '#ff9528';
	const [paymentColor, setPaymentColor] = useState(paymentAmounts.reduce(curr => {
		curr.push({
			backgroundColor: paymentAmountDefColor,
		});
		return curr;
	}, []));


	const changePaymentColorBtn = btn => {
		setPaymentColor(paymentAmounts.reduce((curr, amount, idx) => {
			if (idx===btn) {
				curr.push({
					backgroundColor: paymentAmountHoverColor,
					transform: 'scale(0.97)',
				});
			} else {
				curr.push({
					backgroundColor: paymentAmountDefColor,
					transform: 'scale(1)',
				});
			}
			return curr
		}, []))
	};

	return (
		<div className={css.container}>
			{
				paymentAmounts.map((amount, idx) => {
					return <PaymentAmount style={paymentColor[idx]}
								 nodollar={idx===4}
								 onClick={() => {
								 	changePaymentColorBtn(idx);
								 	handle(idx);
									if (idx!==4) {
										setDonationAmount(amount);
									}
								 }} text={amount} key={idx}/>
				})
			}
		</div>
	);
};

export default PaymentAmounts;
